class Check {
  public cache: any[] = [];
  constructor() {
    this.cache = [];
  }
  add(val: any, rule: string, msg: string) {
    this.cache.push(() => {
      try {
        return strategy[rule].call(Check, val, msg);
      } catch (error) {
        throw new Error(`strategy don't have ${rule} `);
      }
    });
  }
  start() {
    const len = this.cache.length;
    if (len === 0) {
      throw new Error('当前没有验证方法');
    }
    for (let i = 0; i < len; i++) {
      const eroMsg = this.cache[i]();
      if (eroMsg) {
        return eroMsg;
      }
    }
  }
  remove() {
    this.cache = [];
  }
}

const strategy: any = {
  checkImg(val: string[], msg: string) {
    if (val.length < 3) {
      return msg;
    }
  },
  checkName(val: string, msg: string) {
    if (val === '') {
      return msg;
    }
  },
  checkIntro(val: string, msg: string) {
    if (val === '') {
      return msg;
    }
  },
  checkMaterials(val: string, msg: string) {
    if (val === '') {
      return msg;
    }
  },
  checkSize(val: string, msg: string) {
    if (val === '') {
      return msg;
    }
  },
  checkPrice(val: string, msg: string) {
    const rule = /^\+?[1-9][0-9]*$/;
    if (!rule.test(val)) {
      return msg;
    }
  },
  isMobile(tel: string, msg: string) {
    const mobile = /^(13[0-9]{9})|(16[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(19[0-9]{9})|(15[0-9]{9})$/;
    if (tel === '') {
      return '请输入手机号！';
    }
    if (!mobile.test(String(tel)) || String(tel).length !== 11) {
      return msg;
    }
  },
  isIDNumber(id: string, msg: string) {
    const test = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    const test1 = /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/;
    const test2 = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/;
    if (id === '') {
      return '请输入身份证号！';
    }
    if (id.indexOf('(') !== -1) {
      return '';
    } else if (test.test(id)) {
      return '';
    } else if (test1.test(id)) {
      return '';
    } else if (!test2.test(id)) {
      return '';
    } else {
      return msg;
    }
  },
};

const shareFn = (app: any, data?: any) => {
  const {
    title = '“开放的六月”四川美术学院云端艺术游学生作品上传平台',
    subtitle = '“开放的六月”四川美术学院云端艺术游学生作品上传平台',
    imgSrc = 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
  } = data;
  app.$appShareInfo({
    title,
    url: window.location.href,
    subtitle,
    classId: -1,
    id: -1,
    image: imgSrc,
    type: 3,
  });
  app.$wxShareInfo({
    title,
    subtitle,
    image: imgSrc,
  });
};

const judgeDate = (val1: number, val2: number) => {
  return val1 > val2;
};

const checkForm = new Check();

export { checkForm, strategy, shareFn, judgeDate };
